import React from "react";
import { Modal, Form } from "react-bootstrap";
import { Formik } from "formik";
import * as Yup from "yup";
import { useDispatch } from "react-redux";
import { createCompanyCategory, updateCompanyCategory } from "../../../redux/slice/companyCategorySlice";
import { FormLabel } from "../../../components/form/utils";
import CommonButton from "../../../components/commonButton";
import withModal from "../../../components/withModal";
import InputField from "../../../components/form/InputField";

const validationSchema = Yup.object().shape({
    name: Yup.string().required("Category name is required"),
    is_active: Yup.boolean()
});

const CompanyCategoryModalInner = ({ onClose, item, refresh, isView }) => {
    const dispatch = useDispatch();
    const isEdit = Boolean(item);

    const initialValues = {
        name: item?.name || "",
        is_active: item?.is_active ?? true,
    };

    const handleSubmit = async (values, { setSubmitting }) => {
        try {
            if (isEdit) {
                await dispatch(updateCompanyCategory({ id: item.id, data: values })).unwrap();
            } else {
                await dispatch(createCompanyCategory(values)).unwrap();
            }
            refresh();
            onClose();
        } catch (error) {
            console.error("Failed to save category:", error);
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
            enableReinitialize
        >
            {({ values, errors, touched, handleChange, handleSubmit, isSubmitting, setFieldValue }) => (
                <Form onSubmit={handleSubmit}>
                    <Modal.Body>
                        <InputField
                            label={{ name: "Category Name" }}
                            className="mb-3"
                            input={{
                                id: "name",
                                name: "name",
                                placeholder: "Enter category name",
                                value: values.name,
                                onChange: handleChange,
                            }}
                            validation={{
                                isInvalid: touched.name && errors.name,
                                message: errors.name,
                            }} />

                        <div >
                            <FormLabel labelName="Status" />

                            <Form.Check
                                type="switch"
                                name="is_active"
                                label={values.is_active ? "Active" : "Inactive"}
                                checked={values.is_active}
                                onChange={(e) => setFieldValue("is_active", e.target.checked)}
                                className="cursor-pointer custom-plan-switch"
                                disabled={isView}
                            />

                        </div>
                    </Modal.Body>
                    <Modal.Footer >
                        <CommonButton
                            title="Cancel"
                            variant="outline"
                            onClick={onClose}
                            type="button"
                        />
                        {!isView && (
                            <CommonButton
                                title={isSubmitting ? "Saving..." : isEdit ? "Update" : "Create"}
                                type="submit"
                                variant="primary"
                                disabled={isSubmitting}
                            />
                        )}
                    </Modal.Footer>
                </Form>
            )}
        </Formik>
    );
};

const CompanyCategoryModal = withModal(CompanyCategoryModalInner);

export default CompanyCategoryModal;
